<template>
  <div class="container">
    <nav class="top-navbar fixed-top text-center">
      <a href="#/" target="_self" class="navbar-brand m-2">
        <img src="/img/svg/expense_guide_logo_inside.svg" alt="expense.guide logo" class="logo-topnav">
      </a>
    </nav>
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Register</div>
          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

              <div class="col-md-6">
                <input id="name" v-model="form.name" :class="{ 'is-invalid': errors.name }" type="text" class="form-control" value="" required autofocus>
                <span v-if="errors.name" class="invalid-feedback">
                  <div v-for="(error, index) in errors.name" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label text-md-right">E-Mail Address</label>

              <div class="col-md-6">
                <input id="email" v-model="form.email" :class="{ 'is-invalid': errors.email }" type="email" class="form-control" value="" required>
                <span v-if="errors.email" class="invalid-feedback">
                  <div v-for="(error, index) in errors.email" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

              <div class="col-md-6">
                <input id="password" v-model="form.password" :class="{ 'is-invalid': errors.password }" type="password" class="form-control" required>
                <span v-if="errors.password" class="invalid-feedback">
                  <div v-for="(error, index) in errors.password" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="password-confirm" class="col-md-4 col-form-label text-md-right">Confirm Password</label>

              <div class="col-md-6">
                <input id="password-confirm" v-model="form.password_confirmation" :class="{ 'is-invalid': errors.password_confirmation }" type="password" class="form-control" required>
                <span v-if="errors.password_confirmation" class="invalid-feedback">
                  <div v-for="(error, index) in errors.password_confirmation" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="termsAndConditions" class="col-md-4 col-form-label text-md-right"/>

              <div class="col-md-6">
                <b-form-checkbox id="termsAndConditions"
                                 v-model="form.terms"
                                 :value="true"
                                 :unchecked-value="false">
                  I accept the <a href="/#/privacy-policy">Privacy Policy</a> and the <a href="/#/terms-of-service">Terms of Service</a>
                </b-form-checkbox>
                <span v-if="errors.terms" class="invalid-feedback" style="display:block">
                  <div v-for="(error, index) in errors.terms" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4">
                <button type="button" class="btn btn-primary" @click.prevent="submit()">
                  <span v-if="this.$loading.isLoading('registering')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Register
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Registration',
  data () {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        terms: false,
        referral_id: localStorage.getItem('referral_id') ? localStorage.getItem('referral_id') : ''
      },
      error: '',
      errors: {},
      registrationCompleted: false
    }
  },
  computed: {
    ...mapState({
      state: state => state
    })
  },
  created: function () {
    if (this.state.auth.registrationData) {
      this.form.name = this.state.auth.registrationData.name
      this.form.email = this.state.auth.registrationData.email
      this.form.password = this.state.auth.registrationData.password
      this.form.password_confirmation = this.state.auth.registrationData.password_confirmation
      this.form.terms = this.state.auth.registrationData.terms
    }
  },
  beforeDestroy: function () {
    if (!this.registrationCompleted) {
      let data = JSON.parse(JSON.stringify(this.form))
      this.SET_REGISTRATION_DATA(data)
    }
  },
  methods: {
    ...mapMutations([
      'SET_REGISTRATION_DATA',
      'UNSET_REGISTRATION_DATA'
    ]),
    ...mapActions([
      'register'
    ]),
    submit () {
      this.$loading.startLoading('registering')
      this.errors = {}
      this.register(this.form)
        .then(() => {
          this.registrationCompleted = true
          this.UNSET_REGISTRATION_DATA()
          this.$loading.endLoading('registering')
          localStorage.removeItem('referral_id')
          this.$router.replace('/dashboard')
        })
        .catch((data) => {
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('registering')
        })
    }
  }
}
</script>
